import React, { useEffect, useState, Fragment } from 'react';
import Layout from 'components/sales/layout/layout';
import TableSection from 'components/sales/tableSection/tableSection';
import Images from 'assets/images/imageData';
import localization from 'assets/localization/localization';
import ModalPop from 'components/sales/modal/modal';
import FileUpload from 'components/sales/fileUpload/fileUpload';
import DropDownInput from 'components/sales/Input/dropDownInput/dropDownInput';
import { Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import ListFilters from 'components/sales/ListFilters/ListFilters';

const PmSities = ({
  fetchPmSities,
  pmSitiesData,
  fetchMonth,
  postApprovePmSite,
  getPmSitiesFilterDropDown,
  pmdropdownList,
}) => {
  const [isLoading, setIsLoading] = useState(false);
  const [listData, setListData] = useState();
  const [pageCount, setPageCount] = useState(0);
  const [isFiled, setIsFiled] = useState(false);
  const [refresh, setRefresh] = useState(false);
  const [filterData, setFilterData] = useState(null);
  const [showFilter, setShowFilter] = useState(false);

  const headers = [
    'Site Number',
    'Schd. Mnt. Date',
    'Site Type',
    'Client Name',
    'Area Name',
    'Assigned To',
    'Feeback Rating',
    'Feedback Remark',
    'Status',
    'Actions',
  ];

  const headerBtns = () => {
    return (
      <Fragment>
        <Button
          onClick={filterToggle}
          className="filter-hamburger btn btn-transparent"
        >
          <img src={Images?.Filter} alt=""></img>
          {localization.showFilters}
        </Button>
      </Fragment>
    );
  };

  useEffect(() => {
    const installationCont = JSON.parse(
      localStorage.getItem("pmSiteCont") &&
        localStorage.getItem("pmSiteCont")
    );
    if(installationCont){
      localStorage.setItem("pmList", JSON.stringify(""));
      localStorage.setItem("pmSiteCont", 0);
    }
    
  }, []);

  const filterToggle = () => {
    setShowFilter(!showFilter);
  };

  const applyFilter = async (filterData) => {
    localStorage.setItem("pmList", JSON.stringify(filterData));
    setIsLoading(true);
    setFilterData(filterData);
    await fetchPmSities(filterData, 1);
    setIsLoading(false);
    filterToggle();
  };

  useEffect(() => {
    if (fetchPmSities !== null)
      (async () => {
        setIsLoading(true);
        const dashBoardFilter = await JSON.parse(
          localStorage.getItem("dashBoardFilter") &&
            localStorage.getItem("dashBoardFilter")
        );
        const getcontractFilter = await JSON.parse(
          localStorage.getItem("pmList") &&
            localStorage.getItem("pmList")
        );
        // setFilterData({
        //   site_no: '',
        //   client_name: '',
        //   site_type: '',
        //   status: (dashBoardFilter.status)?dashBoardFilter.status:[4,5,7],
        //   assignee_ids: '',
        //   fromDate: (dashBoardFilter.fromFilterDate)?dashBoardFilter.fromFilterDate:'',
        //   toDate: (dashBoardFilter.toFilterDate)?dashBoardFilter.toFilterDate:'',
        // });
        if(dashBoardFilter){
          localStorage.setItem("pmList", JSON.stringify(""));
          localStorage.setItem("pmSiteCont", 0);
          await fetchPmSities({
            site_no: '',
            client_name: '',
            site_type: '',
            status: (dashBoardFilter.status)?dashBoardFilter.status:[4,5,7],
            assignee_ids: '',
            city_id:'',
            fromDate: (dashBoardFilter.fromFilterDate)?dashBoardFilter.fromFilterDate:'',
            toDate: (dashBoardFilter.toFilterDate)?dashBoardFilter.toFilterDate:'',
          });
        }
        else if(getcontractFilter){
          await fetchPmSities(getcontractFilter);
        }
        else{
          await fetchPmSities({
            site_no: '',
            client_name: '',
            site_type: '',
            status: [4,5,7],
            assignee_ids: '',
            city_id:'',
            fromDate: '',
            toDate: '',
          });
        }
        
        await fetchMonth();
        await getPmSitiesFilterDropDown();
        setIsLoading(false);
        localStorage.setItem("dashBoardFilter", JSON.stringify(''));
      })();
  }, [fetchPmSities]);

  useEffect(() => {
    if (refresh === true)
      (async () => {
        setIsLoading(true);
        await fetchPmSities({
          site_no: '',
          client_name: '',
          site_type: '',
          status: [4,5,7],
          assignee_ids: '',
          city_id:'',
        });
        await fetchMonth();
        setIsLoading(false);
      })();
  }, [refresh]);

  const onPageChange = async (val) => {
    setIsLoading(true);
    if(filterData === null){
      await fetchPmSities({
        site_no: '',
        client_name: '',
        site_type: '',
        status: [4,5,7],
        assignee_ids: '',
        city_id:'',
      }, val.selected + 1);
    }else{
      // filterData.status = "4,5,7";
      await fetchPmSities(filterData, val.selected + 1);
    }

    
    // let filter = filterData === null ? null : filterData;
   
   
    setIsLoading(false);
  };

  useEffect(() => {
    const actions1 = [
      { name: 'View Report', link: '/dashboard/view-report-pm' },
      // { name: 'Approve', link: '' },
    ];

    const tableData = [
      'id',
      'site_id',
      'site_no',
      'maintaince_date',
      'site_type',
      'client_name',
      'area_name',
      'assigned_to',
      'feedback_rating',
      'feedback_remark',
      'status',
    ];
    if (pmSitiesData && pmSitiesData.resultSets) {
      const data = pmSitiesData.resultSets.map((element) =>
        Object.assign(
          {},
          ...tableData.map((key) => ({ [key]: element[key] })),
          {
            Action:
              (element.status_value === 5 || element.status_value === 7)
                ? [{ name: 'View Report', link: '/dashboard/view-report-pm' }]
                : actions1,
          }
        )
      );
      if (data) {
        const newData = data.map(function (obj) {
          obj['manage_id'] = obj['id'];
          delete obj['id'];
          obj['id'] = obj['site_id']; // Assign new key
          delete obj['site_id']; // Delete old key
          return obj;
        });
        setListData(newData);
      }
      setPageCount(Math.ceil(pmSitiesData.total / pmSitiesData.per_page));
    }
  }, [pmSitiesData, refresh]);

  return (
    <Layout
      title={localization.approvalPmSites}
      Buttons={headerBtns}
      className={isFiled ? 'requiredFileds' : ''}
      isLoading={isLoading}
    >
      <TableSection
        data={listData}
        isId={false}
        isMngId={false}
        headers={headers}
        srNo={pmSitiesData?.from}
        pageCount={pageCount}
        onPageChange={onPageChange}
        detailList={pmSitiesData && pmSitiesData.resultSets}
        postApprovePmSite={postApprovePmSite}
        refreshPage={(val) => {
          if (val === true) {
            setRefresh(true);
          }
        }}
      />

      <ListFilters
        showFilter={showFilter}
        filterToggle={filterToggle}
        applyFilter={(val) => applyFilter(val)}
        statusId={'4,5,7'}
        listFilterData={pmdropdownList?.site_type ? pmdropdownList : null}
        pmApprovalList={true}
        pmdropdownList={false}
      />
    </Layout>
  );
};
export default PmSities;
